<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M7.70117 0.93457C7.82411 0.688656 8.17589 0.688657 8.29883 0.93457L15.2129 14.7666C15.3239 14.9886 15.1628 15.2499 14.915 15.25H1.10352L1.02832 15.2441C0.814209 15.2101 0.685205 14.9704 0.787109 14.7666L7.70117 0.93457Z" stroke="currentColor" stroke-width="1.5"/>
    <path d="M8 6L8 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M8 13L8 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconAlertSimple'
}
</script>
